// Avatar styles from DiceBear (только указанные стили)
export const AVATAR_STYLES = [
  'fun-emoji',
  'bottts-neutral',
  'thumbs',
  'rings',
  'identicon',
] as const;

export type AvatarStyle = typeof AVATAR_STYLES[number];

// Generate a random seed
export const generateAvatarSeed = (): string => {
  return Math.random().toString(36).substring(2, 15);
};

// Get random avatar style
export const getRandomAvatarStyle = (): AvatarStyle => {
  return AVATAR_STYLES[Math.floor(Math.random() * AVATAR_STYLES.length)];
};

// Generate avatar URL from DiceBear
export const generateDiceBearUrl = (style: AvatarStyle, seed: string): string => {
  return `https://api.dicebear.com/7.x/${style}/svg?seed=${encodeURIComponent(seed)}&backgroundColor=b6e3f4,c0aede,d1d4f9`;
};

// Generate random avatar URL for new users
export const generateRandomAvatarUrl = (identifier: string): string => {
  const style = getRandomAvatarStyle();
  const seed = generateAvatarSeed() + '-' + identifier;
  return generateDiceBearUrl(style, seed);
};
